import { Route } from 'types/route.type';
import ViewFishGroup from './view-fish-group';

export const routes: Route[] = [
  {
    path: '/planning-prognosis/sites/:siteTab/:localSiteId/:fishGroupTab/:fishGroupId',
    component: ViewFishGroup,
  },
];
